import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFileUploaderModule } from 'angular-file-uploader';
import { MediaManagerComponent } from './media-manager.component';
import { SelectMediaComponent } from './select-media/select-media.component';
import { ModalModule } from 'src/app/theme/shared/components/modal/modal.module';
import { CardModule } from 'src/app/theme/shared/components/card/card.module';


@NgModule({
  declarations: [ MediaManagerComponent, SelectMediaComponent ],
  imports: [
    CommonModule,
    AngularFileUploaderModule,
    ModalModule,
    CardModule
  ],
  exports: [ MediaManagerComponent, SelectMediaComponent ]
})
export class MediaManagerModule { }
